module.exports = require('./lib/spine');